<template>
   <div  class="popup"  v-show="attentionShow" v-cloak>
          <div class="content" id='backupAttention'>
              <div class="title">
               Attention
              <div class="icon white-close dialog-close" @click="attentionShow=false"></div>
              </div>
                  <div class="backupAttion-body">
                       <div style="margin:0 auto;width:300Px;height:100Px;">
                            <div style="fontSize:14Px;color:#6f7886;float:left;">{{$t('language.cloudBackup.deleteVersion')}}</div>
                            <div style="marginTop:10Px;float:left;">
                                <div :class="check?'check':'nocheck'" @click="checkItem()" class="icon-util" style="float:left;marginRight:10Px;"></div>
                                <div style="float:left;position:relative;top:1Px;">{{$t('language.cloudBackup.deleteFiles')}}</div>
                                <div class="icon-util question-max-mark" id="maxMark">
                                     <div class="version-explanation">
                                         <font v-html="$t('language.cloudBackup.longerDelete')"></font>
                                    </div>
                                </div>
                            </div>
                            <div style="float:left;width:100%;height:40Px;marginTop:10Px;">
                                 <button style="width:110Px;marginRight:20Px;" @click="deleteItem()">{{$t('language.common.delete')}}</button>
                                 <button  class="cancel-button" @click="close()">{{$t('language.common.cancel')}}</button>
                            </div>
                         </div>
                 </div>
          </div>
  </div>
</template>

<script>
import taskListUtils from "@/js/workspace/task_list_util.js";
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data:function(){
        return{
          attentionShow:false,
          check:false,
          item:''
        }
    },
    methods:{
        checkItem(){
           this.check=!this.check;
        },
        close(){
            this.attentionShow=false;
            this.check = false;
        },
        deleteItem(){
           let that = this;
           let user=commonUtils.getUser();
           //console.log(this.item);
           let deteData = new taskListUtils.deleteVersionDate(user.id,this.item.taskId,this.item.id,6,this.check);
           this.Utils.doTasksRequest('delete_version',deteData).then(res=>{
                 if(res.status==200){
                     this.check = false;
                     let versions=Object.assign([],that.$parent.$refs.versionsDialog.versions); 
                     $.each(versions,function(j,jItem){
                         if(that.item.versionNum == jItem.versionNum){
                             that.$parent.$refs.versionsDialog.versions.splice(j,1);
                             //如果已经没有版本了
                             if(that.$parent.$refs.versionsDialog.versions.length==0){
                                 that.$parent.$refs.versionsDialog.notRunShow = true;
                             }
                             return false;
                         }
                     });

                 }
           });
           that.attentionShow=false;
        }
    }

}
</script>

<style>
#maxMark{
    position: relative;
}
#backupAttention{
 width: 420Px;
 height: 220Px;
}
.backupAttion-body{
    width: 100%;
    height: 180Px;
    text-align: center;
    display: flex;
    align-items: center;
}
.version-explanation {
    display: none;
    width: 350Px;
    border: 1Px solid #8a96e3;
    font-size: 12Px;
    position: absolute;
    background-color: #fff;
    padding: 5Px;
    top: 15Px;
    left: 15Px;
}
#maxMark:hover .version-explanation{
    display: block;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/task_list_popups/delete_version_attention_popup.vue